import React, { useState, useEffect } from "react";
import "./App.css";

function App() {
  const [choice, setChoice] = useState("");
  const [details, setDetails] = useState("");
  const [name, setName] = useState("");
  const [choicesList, setChoicesList] = useState([]);
  const [error, setError] = useState("");

  //  Charger la liste au démarrage
  useEffect(() => {
    const fetchChoices = async () => {
      try {
        // const response = await fetch("/choices");
        const response = await fetch("http://localhost:5000/choices");
        if (!response.ok) {
          console.error("Erreur lors du chargement des choix");
          return;
        }
        const data = await response.json();
        setChoicesList(data);
        setError("");
      } catch (error) {
        setError("Impossible de récupérer la liste (serveur indisponible).");
      }
    };
    fetchChoices();
    // fetch("http://localhost:5000/choices")
    //   .then((res) => res.json())
    //   .then((data) => setChoicesList(data));
  }, []);


  const handleSubmit = async () => {
    if (!choice || !details || !name) {
      return alert("Veuillez remplir tous les champs !");
    }

    try {
      // await fetch("/add-choice", {
      const response = await fetch("http://localhost:5000/add-choice", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ name, choice, details }),
      });

      if (!response.ok) throw new Error("Serveur indisponible");

      // Recharger la liste après ajout
      const updatedList = await fetch("http://localhost:5000/choices").then((res) => res.json());
      setChoicesList(updatedList);

      alert("Votre choix a été enregistré !");
      setDetails("");
      setName("");
      setChoice("");
      setError("");
    } catch (error) {
      setError("Impossible d'enregistrer votre choix (serveur indisponible).");
    };
  };


  return (
    <div className="container">
      <h1>Mariage participatif de Xavina et Samuel</h1>

      <p>
        Nous avons le plaisir de vous inviter à notre mariage
      </p>

      <p><strong>Date : </strong>Le 16 mai 2026 à 14h00</p>

      <img src="/images/amar-hotes.jpg" alt="Lieu" />
      <p><strong>Lieu : </strong> Amar et Hôtes<br />
        Rue de l'Abattoir 34, 5060 Sambreville</p>

      <p>
        Afin de réaliser un mariage convivial et chaleureux et à notre image.
        Nous vous invitons à participer activement à notre mariage 
        en apportant un élément de votre choix pour l'apéro ou le dessert.
      </p>

      <h2>Menu</h2>
      <ul>
        <li>Couscous</li>
        <li>BBQ (apportez votre viande)</li>
      </ul>

      <h3>Chaque ménage apporte</h3>
      <div className="choice-container">
        <div
          className={`choice-box ${choice === "l'apéro" ? "selected" : ""}`}
          onClick={() => setChoice("l'apéro")}
        >
          🥨 Soit 1 apéro
        </div>
        <div
          className={`choice-box ${choice === "le dessert" ? "selected" : ""}`}
          onClick={() => setChoice("le dessert")}
        >
          🍰 Soit 1 dessert pour 10 personnes
        </div>
      </div>

      {!error && <>
        <div className="form">
          <input
            type="text"
            placeholder="Votre nom"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <textarea
            placeholder={`Que comptez-vous apporter pour ${choice || "..."}`}
            value={details}
            onChange={(e) => setDetails(e.target.value)}
          />
          <button onClick={handleSubmit}>Enregistrer</button>
        </div>
      </>}

      {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}

      {!error && (
        <>
          <h3>Liste des apports :</h3>
          <div className="list-container">
            {choicesList.length === 0 ? (
              <p>Aucun choix enregistré pour le moment.</p>
            ) : (
              <ul>
                {choicesList.map((item, index) => (
                  <li key={index}>
                    <strong>{item.name}</strong> → {item.choice} : {item.details}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </>
      )}
    </div>
  );
}

export default App;
